<div class="copyright">
    <div class="container">
        <p>CNPJ: <strong>10.345.578/0001-33</strong> / JPG VIAGENS E TURISMO LTDA</p>
        <p>Todos os direitos reservados - <strong>{{config.nome}}</strong> - 2023 | Desenvolvido por <a href="https://digitalmovement.com.br/" title="Digital Movement - Agência Digital" target="_blank">Digital Movement <img src='/images/digital-movement/logo.svg' alt="Digital Movement - Agência Digital" width="20px" height="20px"  /></a></p>
    </div>    
</div>    